<template>
  <Loader v-if="loader" />
  <div class="card">
    <h3>Carica Contabile</h3>
    <div class="formgrid grid form-file">
      <div class="field col-12 md:col-4">
        <label>Importo*</label>
        <InputText class="w-full" v-model="contabile.importo" />
        <div v-show="validationErrors.importo && submitted" class="p-error">Formato errato.</div>
      </div>
      <div class="field col-12 md:col-4">
        <label>Numero Fattura/e*</label>
        <Textarea class="w-full uppercase" v-model="contabile.fatture" placeholder="E123456;E123458" />
        <div v-show="validationErrors.fatture && submitted" class="p-error">Campo richiesto.</div>
      </div>
      <div class="field col-12 md:col-4">
        <label>Data valuta*</label>
        <Calendar class="w-full" v-model="contabile.date" dateFormat="dd-mm-yy" :showIcon="true" />
        <div v-show="validationErrors.date && submitted" class="p-error">Campo richiesto.</div>
      </div>
      <div class="field col-12 md:col-4">
        <label>File</label>
        <div class="button-wrapper">
          <span :class="['label', {'active': contabile.fileToUpload.length > 0}]">
            {{contabile.fileToUpload.length > 0 ? contabile.fileToUpload[0].name : 'Seleziona File' }}
          </span>
          <input id="upload" type="file" ref="file" @change="handleFileUpload($event)" :accept="`${Object.values(allowedType).join(', ')}`" />
        </div>
        <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
        <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
      </div>
      <div class="field col-12 md:col-4">
        <label>Tipo contabile</label>
        <Dropdown v-model="contabile.tipo" :options="tipi" optionLabel="name" optionValue="name" placeholder="Seleziona una tipologia" class="inputfield w-full" />
      </div>
      <div class="field col-12 md:col-4">
        <label>Note</label>
        <InputText class="w-full" v-model="contabile.note" />
        <div v-show="validationErrors.note && submitted" class="p-error">Campo richiesto.</div>
      </div>
      <div class="field col-12 flex align-items-center justify-content-center">
        <Button @click="verifyNewContabile" class="w-3 p-button-secondary" label="Verifica Contabile" />
      </div>
    </div>
  </div>

  <div class="mt-5">
    <h4>Fatture con contabili</h4>
    <DataTable ref="dtContabili" :value="contabili" dataKey="id" :paginator="true" :rows="10" :filters="contabiliFilters" :rowClass="rowClass"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25,100, 500,1000]"
        currentPageReportTemplate="{first} a {last} di {totalRecords} records" responsiveLayout="scroll">
        <template #header>
          <div class="flex justify-content-between flex-wrap">
              <div class="flex align-items-center justify-content-center mb-2">
                 <div class="flex align-items-center ml-4">
                    <TriStateCheckbox @change="filterData" v-model="checked_expire" />
                    <label class="ml-2"> {{checked_expire == null ? 'Tutte' : (checked_expire == false ? 'Scadute' : 'Non scadute')}}</label>
                </div>
                <div class="flex align-items-center ml-4">
                   <Dropdown @change="filterData" v-model="selectedDateCaricamento" :options="datesCaricamento" placeholder="Seleziona data caricamento" class="inputfield w-full" />
                </div>
                <div class="flex align-items-center ml-4">
                   <Dropdown @change="filterData" v-model="selectedAgente" :options="agenti" placeholder="Seleziona agente" class="inputfield w-full" />
                </div>
              </div>
              <div class="flex align-items-center justify-content-center">
                <Button icon="pi pi-download" label="Esporta" @click="exportCSV('contabili')" class="p-button-secondary" />
              </div>
          </div>
        </template>
        <template #empty>
            <div class="text-center">Nessun dato trovato.</div>
        </template>
        
        <Column field="numero_fattura" header="Numero fattura"></Column>
        <Column field="importo_totale_contabile" header="Importo Totale contabile">
          <template #body="{ data, field }">
            <span @click="viewInvoicesAssociateToContabile(data)" class="cursor-pointer">
              {{ data[field] }}
            </span>
          </template>
        </Column>
        <Column field="cliente" header="Cliente"></Column>
        <Column field="pagato" header="Pagato fattura"></Column>
        <Column field="importo" header="Importo allocato (contabile)"></Column>
        <Column field="saldo" header="Saldo fattura (con contabile)">
         <template #body="{ data, field }">
            {{ (data[field] - parseFloat(data.importo)).toFixed(2) }}
          </template>
        </Column>
        <Column field="totale_fattura" header="Totale fattura"></Column>
        <Column field="tipo" header="Tipo"></Column>
        <Column field="data_valuta" header="Data Valuta" style="min-width: 120px">
          <template #body="{ data, field }">
            {{ formatDate(data[field]) }}
          </template>
        </Column>
        <Column field="data_caricamento" header="Data Caricamento" style="min-width: 120px">
          <template #body="{ data, field }">
            {{ formatDate(data[field]) }}
          </template>
        </Column>
        <Column field="effettuato_da" header="Effettuato da"></Column>
        <Column field="rappresentante" header="Rappresentante"></Column>
        <Column field="agente" header="Agente"></Column>
        <Column field="note" header="Note"></Column>
        <Column field="path_file" header="File">
          <template #body="{ data, field }">
            <span v-if="data[field]">
              <Button icon="pi pi-download" class="p-button-rounded p-button-success mr-2" @click="downloadContabileFile(data[field])" />
            </span>
          </template>
        </Column>
        <Column :exportable="false" style="min-width:8rem">
          <template #body="{ data }">
            <i @click="deleteContabile(data.id)" class="pi pi-trash p-error cursor-pointer"></i>
          </template>
        </Column>
        <ColumnGroup type="footer" :key="totale_contabili">
          <Row>
              <Column footer="Totale:" :colspan="3" footerStyle="text-align:right"/>
              <Column style="text-align:right" :footer="totale_contabili" />
              <Column :colspan="11"/>
          </Row>
        </ColumnGroup>
    </DataTable>
  </div>

  <!-- Dialog verify newContabile -->
  <Dialog modal header="Verifica Contabile" v-model:visible="verifyContabileDialog" :style="{ width: '90vw' }">
      <div class="grid">
        <div class="col-12">
          <h6 v-if="verifyItems.fatture_not_found.length > 0" class="p-error"> <b>Fatture non trovate:</b> <small>{{verifyItems.fatture_not_found.length}} ({{verifyItems.fatture_not_found.join(', ')}})</small></h6>
          <h6 v-if="verifyItems.importo_avanzato > 0" class="p-error"> <b>Importo contabile avanzato:</b> <small>{{verifyItems.importo_avanzato}}</small></h6>
        </div>
        <div class="col-12">
  <DataTable 
    ref="dtVerify" 
    editMode="cell" 
    @cell-edit-complete="onCellEditComplete" 
    v-model:selection="selectedVerifyItems" 
    :value="verifyItems.fatture" 
    dataKey="id" 
    :paginator="true" 
    :rows="10" 
    :filters="verifyFilters" 
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
    :rowsPerPageOptions="[5, 10, 25]"
    currentPageReportTemplate="{first} a {last} di {totalRecords} records" 
    responsiveLayout="scroll">
      
    <template #header>
      <div class="flex justify-content-between flex-wrap">
        <div class="flex align-items-center justify-content-center mb-2">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText type="search" v-model="verifyFilters['global'].value" placeholder="Cerca..." />
          </span>
        </div>
        <div class="flex align-items-center justify-content-center">
          <Button icon="pi pi-download" label="Esporta" @click="exportCSV('verify')" class="p-button-secondary" />
        </div>
      </div> 
    </template>
    
            <template #empty>
                <div class="text-center">Nessun dato trovato.</div>
            </template>

            <Column selectionMode="multiple" />
            <Column field="numero" header="Numero fattura"></Column>
            <Column field="cliente" header="Cliente"></Column>
            <Column field="fornitura" header="Fornitura"></Column>
            <Column field="totale_fattura" header="Totale fattura"></Column>
            <Column field="pagato" header="Pagato fattura"></Column>
            <Column field="saldo" header="Saldo fattura"></Column>
            <Column field="importo_gia_allocato" header="Importo già allocato">
              <template #body="{ data, field }">
                <span class="text-orange-400">{{ data[field] }}</span>
              </template>
            </Column>
            <Column field="importo_utilizzato" header="Importo da allocare">
              <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
              </template>
              <template #body="{ data, field }">
                <span class="text-blue-400 cursor-pointer">{{ data[field] }}</span>
              </template>
            </Column>
            <Column field="rappresentante" header="Rappresentante"></Column>
            <Column field="agente" header="Agente"></Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
          <Button label="Chiudi" icon="pi pi-times" @click="verifyContabileDialog = false" class="p-button-text p-button-danger"/>
          <Button label="Importa Contabile" icon="pi pi-check" @click="importContabile" class="p-button-text "/>
      </template>
  </Dialog>

  <!-- Dialog invoices associate to contabile -->
  <Dialog modal header="Fatture associate a contabile" v-model:visible="invoicesAssociateToContabileDialog" :style="{ width: '90vw' }">
      <div class="grid">
        <div class="col-12">
          <p>Valore totale contabile: <b>{{ invoicesAssociateToContabile.reduce((a, c) => a + c.totale_fattura, 0) }}</b></p>
          <DataTable :value="invoicesAssociateToContabile" responsiveLayout="scroll">
            <Column field="numero_fattura" header="Numero fattura"></Column>
            <Column field="totale_fattura" header="Totale fattura"></Column>
            <Column field="pagato" header="Pagato fattura"></Column>
            <Column field="saldo" header="Saldo fattura"></Column>
            <Column field="rappresentante" header="Rappresentante"></Column>
            <Column field="agente" header="Agente"></Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
          <Button label="Chiudi" icon="pi pi-times" @click="invoicesAssociateToContabileDialog = false" class="p-button-text p-button-danger"/>
      </template>
  </Dialog>
</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
// import UtilityService from '@/services/ask-management/utility-service'
import { ref, getCurrentInstance, onMounted, onBeforeUnmount, watch, computed  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'
import { useRoute } from 'vue-router';


export default {
    components: {
      Loader
    },
     setup() {
      const dtContabili = ref();
      const dtVerify = ref();
      const route = useRoute();
      const loader = ref(false)
      const contabiliFilters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const verifyFilters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const toast = useToast();
      const verifyItems = ref({
        fatture_not_found: [],
        importo_avanzato: 0,
        fatture: [],
        success: false,
        msg: ''
      })
      const selectedVerifyItems = ref([])
      const tipi = ref([
        {'name' : 'BANCA'},
        {'name' : 'POSTA'},
        {'name' : 'TITOLO'},
      ])
      const contabili = ref([])
      const contabiliOriginal= ref([])
      const contabile = ref({
        'importo': '',
        'fatture': '',
        'note': '',
        'fileToUpload': [],
        'tipo': null,
        'date': new Date(moment(new Date()))
      })
      const allowedType = {
          'pdf': 'application/pdf',
          'png' : 'image/png',
          'jpg' : 'image/jpeg',
          'jpeg' : 'image/jpeg',
          'csv' : 'text/csv',
          'xls' : 'application/vnd.ms-excel',
          'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
      const checked_expire =  ref(null);
      const selectedDateCaricamento = ref(null)
      const datesCaricamento = ref([])
      const selectedAgente = ref(null)
      const agenti = ref([])
      const verifyContabileDialog = ref(false)
      const invoicesAssociateToContabileDialog = ref(false)
      const invoicesAssociateToContabile = ref([])
      const validationErrors = ref({})
      const submitted = ref(false)
      const isUnmounted = ref(false)
      const linkedContabiliIds = ref([])

      onMounted(() =>{
        linkedContabiliIds.value = parseContabiliIds(route.query.id_contabile)
        getContabili()
      })

      onBeforeUnmount(() => {
        isUnmounted.value = true
      })

      watch(
        () => route.query.id_contabile,
        (newValue) => {
          linkedContabiliIds.value = parseContabiliIds(newValue)
          filterData()
        }
      )

      const parseContabiliIds = (rawValue) => {
        if (!rawValue) return []

        const value = Array.isArray(rawValue) ? rawValue.join(',') : String(rawValue)
        return value
          .split(',')
          .map((id) => id.trim())
          .filter((id) => id.length > 0)
      }

      const getLoggedUser = () => {
        try {
          const stored = localStorage.getItem('user')
          if (!stored) return null
          return JSON.parse(atob(stored)).user[0]
        } catch (e) {
          return null
        }
      }


      const getContabili = () => {
        loader.value = true
        service.getContabili(contabile.value)
          .then((res) => {
            if (isUnmounted.value) return
            contabili.value = res.items
            contabiliOriginal.value = res.items
            checked_expire.value = null
            if (contabiliOriginal.value.length > 0) {
              let arrDates = ['tutte']
              contabiliOriginal.value.forEach(el => {
                arrDates.push(formatDate(el.data_caricamento))
              });
              datesCaricamento.value = [...new Set(arrDates)];
              let arrAgents = ['tutti']
              contabiliOriginal.value.forEach(el => {
                arrAgents.push(el.agente)
              });
              agenti.value = [...new Set(arrAgents)];
            }
            filterData()
          })
          .finally(()=>{
            if (isUnmounted.value) return
            loader.value = false
          }) 
      }


      const handleFileUpload = async (evt) => {
        contabile.value.fileToUpload = []
        evt.preventDefault()
        submitted.value = false;
        contabile.value.fileToUpload = self.refs.file.files
      }

      const verifyNewContabile = () => {
        submitted.value = true;
        if (validateNewContabile()) {
          loader.value = true
          contabile.value.fatture = (contabile.value.fatture.split(/\r?\n/)).join(';');
          contabile.value.date = moment(contabile.value.date).format('YYYY-MM-DD')
          service.verifyNewContabile(contabile.value)
          .then((res) => {
            verifyItems.value = res.items
            if (verifyItems.value.success) {
              selectedVerifyItems.value = verifyItems.value.fatture.filter( el => el.importo_utilizzato != 0)
              // se solo una fattura permetti qualsiasi importo
              if(selectedVerifyItems.value.length == 1){
                // selectedVerifyItems.value[0].importo_gia_allocato = 0
                selectedVerifyItems.value[0].importo_utilizzato = contabile.value.importo
              }
              verifyContabileDialog.value = true
              //toast.add({severity:'success', summary: 'Successo', detail:verifyItems.value.msg});
            } else {
              toast.add({severity:'warn', summary: 'Attenzione', detail:verifyItems.value.msg});
            }
          })
          .finally(()=>{
            loader.value = false
          }) 
        }

      }

      const importContabile = () => {
        if (validateImportContabile()) {
          
          if ( selectedVerifyItems.value.length > 0) {
            loader.value = true
            verifyItems.value.fatture = selectedVerifyItems.value
            const loggedUser = getLoggedUser()
            service.importNewContabile({
              ...verifyItems.value,
              user_id: loggedUser?.id ?? null,
              user_role: 'user',
            })
            .then((res)=>{
              if (res.success) {
                verifyContabileDialog.value = false
                toast.add({severity:'success', summary: 'Successo', detail:res.msg});
                contabile.value = {
                  'importo': '',
                  'fatture': '',
                  'note': '',
                  'fileToUpload': [],
                  'tipo': null,
                  'date': new Date(moment(new Date()))
                }
                getContabili()
              } else {
                toast.add({severity:'warn', summary: 'Attenzione', detail:res.msg});
              }
              
            }) 
            .finally(()=>{
              loader.value = false
            })
          } else {
            toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessuna riga selezionata'});
          }
           
        }
      }

      const onCellEditComplete = (event) => {
        selectedVerifyItems.value[event.index][event.field] = event.newValue
      }

      const downloadContabileFile = (path) =>{
        loader.value = true
        service.downloadContabileFile(path)
        .finally(()=>{
          loader.value = false
        })
      }

      const deleteContabile = (id) =>{
        loader.value = true
        service.deleteContabile(id)
        .then((res) => {
          if (res.items.success) {
             toast.add({severity:'success', summary: 'Successo', detail:res.items.msg});
             getContabili()
          } else {
            toast.add({severity:'warn', summary: 'Attenzione', detail:res.items.msg});
          }
        })
        .finally(()=>{
          loader.value = false
        })
      }

      const rowClass = (data) => {
        return [{ 'bg-pink-100': data.is_passed }];
      };


      const filterData = () => {
        // let tempContabili = contabiliOriginal.value
        contabili.value = contabiliOriginal.value

        if (checked_expire.value == false) {
          contabili.value = contabili.value.filter( el => el.is_passed)
        } else if (checked_expire.value == true){
          contabili.value = contabili.value.filter( el => !el.is_passed)
        } 

        if (selectedAgente.value !== null) {
          if (selectedAgente.value != 'tutti') {
            contabili.value =  contabili.value.filter( el => selectedAgente.value == el.agente)
          } 
        }

        if (selectedDateCaricamento.value !== null) {
          if (selectedDateCaricamento.value != 'tutte') {
            contabili.value =  contabili.value.filter( el => (moment(selectedDateCaricamento.value, 'DD-MM-YYYY').format('YYYY-MM-DD')) == el.data_caricamento)
          } 
        }

        if (linkedContabiliIds.value.length > 0) {
          contabili.value = contabili.value.filter((el) => linkedContabiliIds.value.includes(String(el.id)))
        }
      }


      const parseAmount = (value) => {
        if (typeof value === 'number') {
          return Number.isFinite(value) ? value : 0;
        }
        if (value === null || value === undefined) {
          return 0;
        }

        let normalized = String(value).trim().replace(/\s/g, '').replace(/[^\d,.-]/g, '');
        if (!normalized) {
          return 0;
        }

        if (normalized.includes(',') && normalized.includes('.')) {
          normalized = normalized.replace(/\./g, '').replace(',', '.');
        } else if (normalized.includes(',')) {
          normalized = normalized.replace(',', '.');
        }

        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : 0;
      };

      const totale_contabili = computed(() => {
        if (!Array.isArray(contabili.value) || contabili.value.length === 0) {
          return formatCurrency(0);
        }

        const total = contabili.value.reduce((acc, el) => {
          const amount = el?.importo ?? el?.importo_totale_contabile ?? 0;
          return acc + parseAmount(amount);
        }, 0);

        return formatCurrency(total);
      });

      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };


      const validateImportContabile = () => {
        if (selectedVerifyItems.value.length == 1) {
          return true
        }
        let totalSaldo = 0;
        console.log(selectedVerifyItems.value);
        for(let el of selectedVerifyItems.value) {
          totalSaldo += parseFloat(el.saldo - el.importo_gia_allocato)
        }
        
        if (parseFloat(totalSaldo.toFixed(2)) >= parseFloat(contabile.value.importo)) {
          return true
        } else {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Importo allocato (o già allocato) maggiore dell\'importo della contabile '});
          return false
        }

      }

      const viewInvoicesAssociateToContabile = (data) => {
        let uuid = data.uuid
        if (uuid) {
          let invoices = contabili.value.filter(el => el.uuid == uuid)
          if (invoices.length > 0) {
            invoicesAssociateToContabile.value = invoices
            invoicesAssociateToContabileDialog.value = true
          }
        }
      }

      const validateNewContabile = () => {
        validationErrors.value = []
        const regIsNum = new RegExp('^[0-9.,]+$');
      
        if (!regIsNum.test(contabile.value.importo)) {
            validationErrors.value['importo'] = true;
        } else {
          delete validationErrors.value['importo'];
        }

        if (!contabile.value.fatture) {
            validationErrors.value['fatture'] = true;
        } else {
          delete validationErrors.value['fatture'];
        }

        if (contabile.value.fileToUpload.length > 0) {
          let valid = [...contabile.value.fileToUpload].every(file => Object.values(allowedType).includes(file.type), false);
          if (valid) {
            delete validationErrors.value['type'];
          } else {
            validationErrors.value['type'] = true;
          }
            
        }

        if (!contabile.value.date) {
            validationErrors.value['date'] = true;
        } else {
          delete validationErrors.value['date'];
        }

        return !Object.keys(validationErrors.value).length;
    }

    const exportCSV = (table = 'contabili') => {
      const tableRef = table === 'verify' ? dtVerify : dtContabili;
      if (tableRef.value) {
        tableRef.value.exportCSV();
      }
    };

    return { 
      dtContabili,
      dtVerify,
      contabile,
      contabili,
      contabiliOriginal,
      verifyItems,
      selectedVerifyItems,
      tipi,
      loader, 
      service,
      verifyContabileDialog,
      invoicesAssociateToContabileDialog,
      invoicesAssociateToContabile,
      viewInvoicesAssociateToContabile,
      allowedType, 
      contabiliFilters,
      verifyFilters,
      validationErrors,
      submitted,
      handleFileUpload,
      verifyNewContabile,
      importContabile,
      onCellEditComplete,
      downloadContabileFile,
      deleteContabile,
      formatDate,
      rowClass,
      checked_expire,
      selectedDateCaricamento,
      datesCaricamento,
      selectedAgente,
      agenti,
      filterData,
      totale_contabili,
      moment,
      exportCSV
    }
  }
}
</script>

<style scoped>

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
.box-wrapper .box {
  cursor: pointer;
}
.box-wrapper .box .card {
    background-color: #f4f4f4;
    padding-bottom: 8px;
}
.box-wrapper .highlight .card{
  /* background: rgba(66, 244, 17, 0.195); */
  border-bottom: 6px solid rgb(18, 158, 251);
  background-color: #fff;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #cccccc;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #cccccc;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #cccccc;
}
@media (min-width: 769px) {
  :global(.w-3) {
  width:none !important;
}
}
</style>
